import Seo from "@/components/feature/Seo";
import TipForm from "@/components/feature/TipForm";
import { faqs } from "@/mocks/topics";
import HeroSection from "./components/HeroSection";
import TodaySection from "./components/TodaySection";
import HotTopicsSection from "./components/HotTopicsSection";
import CategorySection from "./components/CategorySection";
import FaqSection from "./components/FaqSection";

const submitNotes = [
  "提供公开可见的时间、场合与已发布信息，方便我们核实。",
  "涉及个人隐私的内容，我们会做脱敏处理后再决定是否采用。",
  "同一线索请勿重复提交，我们会按提交顺序逐一处理。",
];

export default function Home() {
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "黑料瓜网",
      url: "https://duopingheyi.cn/",
      description:
        "黑料瓜网聚合今日瓜、大瓜与新瓜速递，提供吃瓜榜单与热议话题整理。",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://duopingheyi.cn/rank?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "黑料瓜网",
      url: "https://duopingheyi.cn/",
      email: "heiliaogua@example.com",
      description: "娱乐热点资讯聚合平台，专注整理公开讨论的娱乐话题。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="黑料瓜网 - 今日瓜大瓜新瓜速递 吃瓜榜单与热议话题"
        description="黑料瓜网专注今日瓜、大瓜与新瓜速递，提供实时刷新的吃瓜榜单与热议话题整理。热门瓜一网打尽，快速掌握全网最热娱乐热议动态，吃瓜不迷路。"
        keywords="黑料瓜网,今日瓜,大瓜,新瓜速递,吃瓜榜单,热议话题"
        path="/"
        schema={schema}
      />
      <HeroSection />
      <TodaySection />
      <HotTopicsSection />
      <CategorySection />
      <FaqSection />

      <section id="submit" className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
              TIPS
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              爆料投稿
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              看到有意思的娱乐话题，欢迎把线索发给我们。核实后我们会整理成话题卡片，放进今日速递和吃瓜榜单。
            </p>
            <ul className="mt-5 flex flex-col gap-3">
              {submitNotes.map((note) => (
                <li key={note} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-checkbox-circle-line mt-0.5 h-4 w-4 shrink-0 flex items-center justify-center text-secondary-600"></i>
                  {note}
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-4 py-3 text-sm text-foreground-700">
              <i className="ri-mail-line h-4 w-4 flex items-center justify-center text-primary-600"></i>
              合作与反馈：heiliaogua@example.com
            </div>
          </div>
          <div className="lg:col-span-2">
            <TipForm />
          </div>
        </div>
      </section>
    </>
  );
}